import { Record } from 'immutable';

const UnassignedReaderRecord = Record({
  studentId: undefined,
  currentLevel: undefined,
  completedInCurrentLevel: undefined,
  totalInCurrentLevel: undefined,
  completedInTotal: undefined,
});

class UnassignedReader extends UnassignedReaderRecord { }

const reviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'currentLevel':
    case 'completedInTotal':
    case 'completedInCurrentLevel':
    case 'totalInCurrentLevel':
      return [key, Number.parseInt(item, 10)];
    case 'studentId':
      return [key, `${item}`];
    default:
      [key, item];
  }
};

UnassignedReader.create = (data) => new UnassignedReader(data).mapEntries(reviver);

export default UnassignedReader;



// WEBPACK FOOTER //
// ./data/Reader/UnassignedReader/model.js